module.exports = __webpack_public_path__ + "img/empty_data.504f674d.png";